const WHATSAPP_LINK = "https://wa.me/557183822916";

export default function CTASection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative bg-petrol-medium py-24 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gold-light/5 rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-light/5 rounded-full translate-x-1/2 translate-y-1/2" />

      {/* Gold accent lines */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-32 h-px bg-gradient-to-r from-transparent to-gold-light/30" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-32 h-px bg-gradient-to-l from-transparent to-gold-light/30" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-3 mb-6">
          <div className="w-8 h-px bg-gold-light/40" />
          <span className="text-gold-light text-xs font-semibold tracking-widest uppercase">
            Precisa de Orientação Jurídica?
          </span>
          <div className="w-8 h-px bg-gold-light/40" />
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
          Fale com um advogado e receba{" "}
          <span className="text-gold-light">orientação jurídica</span> com
          segurança e precisão.
        </h2>

        <p className="text-white/60 text-base leading-relaxed max-w-xl mx-auto mb-12">
          Nossa equipe está pronta para analisar sua situação e indicar o melhor
          caminho jurídico com clareza, ética e comprometimento.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 bg-gold-light hover:bg-gold-medium text-petrol-darkest font-semibold px-8 py-4 rounded-md transition-all duration-300 text-sm tracking-wide whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg" />
            </span>
            Falar pelo WhatsApp
          </a>
        </div>

        {/* Trust indicators */}
        <div className="grid grid-cols-3 gap-8 max-w-sm mx-auto mt-14 pt-10 border-t border-white/10">
          {[
            { icon: "ri-lock-line", label: "Sigilo garantido" },
            { icon: "ri-time-line", label: "Resposta rápida" },
            { icon: "ri-verified-badge-line", label: "OAB inscrito" },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className={`${item.icon} text-gold-light text-xl`} />
              </span>
              <span className="text-white/50 text-xs text-center">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
